import baseHeader from '@/components/mixins/baseHeader'
import searchHeader from '@/components/mixins/searchHeader'
import baseTable from '@/components/mixins/baseTable'
import selectTable from '@/components/mixins/selectTable'
import baseForm from '@/components/mixins/baseForm'
import msgDialog from '@/components/mixins/msgDialog'
import formDialog from '@/components/mixins/formDialog'
import tableDialog from '@/components/mixins/tableDialog'
import { mapGetters } from 'vuex'

export default {
  mixins: [baseHeader, baseTable, msgDialog, formDialog, searchHeader, baseForm, selectTable, tableDialog],
  data () {
    return {
      addFormLoading: false,
      addForm: {
        'content': '',
        'type': ''
      },
      addRules: {
        type: [
          this.$rules.required()
        ],
        content: [
          this.$rules.required()
        ]
      },
      addButtons: [
        {
          text: '保存',
          type: 'Submit'
        }
      ],
      addFormItems: [
        {
          type: 'select',
          label: '内容类型',
          prop: 'type',
          options: [
            {
              value: 'POST',
              label: '录用'
            },
            {
              value: 'CANCELED',
              label: '退稿'
            },
            {
              value: 'REFUND',
              label: '返修'
            }
          ]
        },
        {
          prop: 'content',
          label: '内容',
          maxlength: 100,
          type: 'textarea'
        }
      ],
      type: 1, // 是否正常操作
      asideHeaders: {
        buttons: [
          {
            type: 'Add',
            text: '新建',
            icon: 'xinjian',
            disabled: !this._checkPermission('/admin/roles', 'POST')
          }
        ],
        showAlertIcon: false
      },
      roleList: [], // 角色列表
      delFormLoading: false, // 删除弹框
      delForm: { 'id': 1, 'userId': [], 'orgids': [] },
      delRules: {
        id: [
          this.$rules.required()
        ],
        orgids: [
          this.$rules.required()
        ]
      },
      delButtons: [
        {
          text: '保存',
          type: 'Submit'
        }
      ],
      delFormItems: [
        {
          type: 'cascader',
          prop: 'orgids',
          props: {
            label: 'name',
            value: 'id',
            checkStrictly: true
          },
          label: '选择组织',
          placeholder: '请选择',
          explain: '选择用户移除后归属的组织',
          width: '300px',
          options: []
        }
      ],
      activeName: ''
    }
  },
  methods: {
    handleSelectKeyChange (data) {
      var ids = data.map(v => { return v[this.list.rowKey] })
      this.list.selectedKeys = ids
    },
    handleConfirmAdd (data, btn, type) { // 弹窗新增角色
      this.addFormLoading = true
      var params = data
      if (this.id) {
        params.id = this.id
        this.$request.fetchExtcontentSetUpdate(params).then(res => {
          if (res.code === 200) {
            this.fetchTableApi()
          }
          this.addFormLoading = false
        }).catch(() => {
          this.addFormLoading = false
        })
      } else {
        this.$request.fetchExtcontentSetSave(params).then(res => {
          if (res.code === 200) {
            this.fetchTableApi()
          }
          this.addFormLoading = false
        }).catch(() => {
          this.addFormLoading = false
        })
      }
    }
  },
  computed: {
    // 获取系统设置项
    ...mapGetters(['setting', 'organizeOptions', 'user'])
  }
}
